export default __webpack_public_path__ + "static/media/fb_logo.c99ae09d.png";